import React, {Component} from 'react';
import {renderToString} from 'react-dom/server';
import PropTypes from 'prop-types';
import {INPUT_ACTIONS} from '../../../../../utils/query_utils';
import {inputBlurEvent, inputFocusEvent} from '../../../../../services/query_builder_events';
import {queryBuilderState} from '../../../../../services/query_builder_state';

const KEYS_TO_MONITOR = Object.values(INPUT_ACTIONS);

export default class QueryBuilderInput extends Component {
    input = null;

    constructor(props) {
        super(props);

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setRef = this.setRef.bind(this);

        this.state = {error: false};
    }

    componentDidMount() {
        this.unbindFocusListener = inputFocusEvent.listen(() => { setTimeout(() => { this.forceUpdate(); }, 30); });
        this.unbindBlurListener = inputBlurEvent.listen(() => { setTimeout(() => { this.forceUpdate(); }, 30); });
        setTimeout(() => { this.forceUpdate(); }, 100);
    }

    shouldComponentUpdate(nextProps) {
        return this.input.innerHTML !== nextProps.value;
    }

    componentWillUnmount() {
        this.unbindFocusListener();
        this.unbindBlurListener();
        this.forceUpdate = () => {};
    }

    onFocus() {
        this.props.onFocus(this.input);
    }

    onBlur() {
        if (this.props.propName === 'values' && this.input.innerHTML === '') {
            this.setState({error: true});
        }
        this.props.onBlur(this.input);
    }

    onChange() {
        const value = this.input.innerHTML;
        this.setState({error: value === ''});
        this.props.onChange(value);
    }

    onKeyPress(ev) {
        if (['Enter', ','].includes(ev.key)) {
            ev.preventDefault();
            this.props.onSubmit();
        }
    }

    onKeyDown(ev) {
        if (ev.key === 'Escape') {
            ev.preventDefault();
            this.props.onCancel();
        } else if (KEYS_TO_MONITOR.includes(ev.key)) {
            ev.preventDefault();
            this.props.onKeyPress(ev.key);
        }
    }

    onKeyUp(ev) {
        // pass
    }

    setRef(el) {
        this.input = el;
    }

    isFocused() {
        return queryBuilderState.inputRef && this.input === queryBuilderState.inputRef;
    }

    render() {
        let {value, placeholder, focusedPlaceholder, className, display} = this.props;
        const error = this.state.error;
        const focused = this.isFocused();
        if (focused && focusedPlaceholder) {
            placeholder = focusedPlaceholder;
        }
        return (
            <div
                contentEditable
                className={`input-tag ${focused ? 'focus': ''} ${error ? 'error' : ''} ${className || ''}`}
                data-placeholder={placeholder}
                onFocus={this.onFocus}
                onInput={this.onChange}
                onKeyDown={this.onKeyDown}
                onKeyUp={this.onKeyUp}
                onKeyPress={this.onKeyPress}
                onBlur={this.onBlur}
                ref={this.setRef}
                data-lpignore="true"
                dangerouslySetInnerHTML={{__html: (!focused && display) ? renderToString(display) : value}}
            />
        );
    }
}

QueryBuilderInput.propTypes = {
    value: PropTypes.string,
    display: PropTypes.element,
    placeholder: PropTypes.string,
    focusedPlaceholder: PropTypes.string,
    smallInput: PropTypes.bool,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    propName: PropTypes.string,
};

QueryBuilderInput.defaultProps = {
    value: '',
    placeholder: '',
    focusedPlaceholder: '',
    smallInput: false,
    propName: null,
};
